if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.performRecommendations();
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (!recommendations) return;
      // If the slides are already rendered server-side (the cart-drawer "Complete the set"
      // shows the whole catalogue minus the cart), don't fetch — just reveal + init the slider.
      if (recommendations.children.length > 0) {
        this.classList.remove('hidden');
        this.initSlider();
        return;
      }
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;
          if (!recommendationsHTML) return;
          this.classList.remove('hidden');
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if(cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
          }
          recommendations.innerHTML = recommendationsHTML;
          this.initSlider();

          // initiate quick cart after fetch
          // to activate trigger button events
          setTimeout(() => {
            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            } else {
              // if quick-cart-drawer does not exists, remove trigger buttons
              this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                el?.remove();
              })
            }
          }, 500);

        });
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
        observer: true,
        observeParents: true,
      });
      var self = this;
      // The slides can measure 0-width at init (the fetched product images haven't loaded yet),
      // leaving Swiper thinking there's nothing to scroll — so neither arrows nor swipe move it.
      // Recompute as images load and once shortly after.
      this.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) {
          img.addEventListener('load', function () { if (self.slider) self.slider.update(); }, { once: true });
        }
      });
      setTimeout(function () { if (self.slider) self.slider.update(); }, 400);
      // Wire the prev/next arrows ourselves. Swiper's built-in navigation did NOT bind here
      // (clicking an arrow did nothing — the carousel never moved), and inside the cart drawer
      // that dead click bubbled up and CLOSED the drawer on mobile. Driving the slider directly
      // and stopping propagation fixes both: the arrows scroll, and they never close the cart.
      ['prev', 'next'].forEach(function (dir) {
        var btn = self.querySelector('.product-recommendations__arrow--' + dir);
        if (!btn) return;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (!self.slider) return;
          dir === 'next' ? self.slider.slideNext() : self.slider.slidePrev();
        });
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
